/** Every full-screen view App.svelte can show; `screens.push` and `screens.set` take one. */
export enum Screen {
  Menu = 'menu',
  PlayerSelect = 'playerselect',
  Map = 'map',
  Event = 'event',
  BattleStart = 'battlestart',
  Battle = 'battle',
  BattleOver = 'battleover',
  Upgrade = 'upgrade',
  Styles = 'styles',
  Farm = 'farm',
}
